import styled from "styled-components";

export const PayrollPreparingContainer = styled.div`
  background: ${({theme}) => theme.white};
  border: 1px solid ${({theme}) => theme.grayDivider};
  border-radius: 8px;
  padding: 32px 0 32px 0;
  h1{
    padding: 0 32px 0 32px;
    font-size: 19px;
    font-weight: 700;
    line-height: 23px;
    letter-spacing: 0.4px;
    text-align: left;
    color: ${({theme}) => theme.black}
  }
  h3{
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 22px;
    letter-spacing: 0.3px;
    color: ${({theme}) => theme.gray};
    margin-bottom: 32px;
  }
  section{
    padding: 32px;
    border-bottom: 1px solid ${({theme}) => theme.grayDivider};
  }
  .submit{
    padding: 32px 32px 0 0;
    width: 100%;
    display: flex;
    justify-content: end;
  }
  input[type="file"] {
    display: none;
  }
`

export const PreviewEorInvoice = styled.div`
  width: 100%;
  margin-bottom: 24px;
  padding: 10px 30px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({theme}) => theme.grayBackground};

  button {
    all: unset;
    color: ${({theme}) => theme.accent};
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    margin-bottom: unset;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
  }

  svg {
    margin-left: 8px;

    :hover {
      cursor: pointer;
    }
  }
}
`

export const UploadInvoice = styled.button`
  all: unset;
  width: auto;
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  cursor: pointer;

  p {
    color: ${({theme}) => theme.gray};
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
  }

  .icon {
    margin-right: 8px;
  }
  
  &:hover{
    p{
      text-decoration: underline;
      color: ${({theme}) => theme.accent};
    }
    .icon {
      svg {
        fill: ${({theme}) => theme.accent};
      }
    }
  }
`
